import {
  UPDATED_APPOINTMENT_STEP_DATA,
  UPDATE_SERVICE_DROPDOWN_VISIBILITY,
  UPDATED_STATE_DATE_PICKER_APPOINTMENT,
  GOT_STAFF_SERVICES_AND_MORE,
  GOT_CUSTOMERS_BASED_ON_FILTER,
  UPDATE_IS_SHOWING_ADDRESS_FORM,
  UPDATE_TEMP_BOOKING_ADDRESS,
  UPDATED_APPOINTMENT_STEP_START_DATE_TIME,
  UPDATE_TEMP_ADDRESS_DATA,
  GET_CUSTOMERS_BASED_ON_FILTER,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
  UPDATE_CUSTOMER_DROPDOWN_VISIBILITY,
  CLEAR_ADDRESS_FORM_IN_APPOINTMENT_STEP,
  GOT_PROFILE_FOR_CURRENT_USER,
  MOVE_APPOINTMENT_TRIGGERED,
  UPDATE_CURRENTLY_LOGGED_IN_STAFF,
} from "../actions/appointmentStep";
import {
  SAVED_BOOKING_FORM,
  GOT_EXISTING_BOOKING,
  GOT_SIBBLING_BOOKING,
  GOT_PURCHASED_OFFER,
  REMOVE_OFFER_FROM_FORM,
  GET_EXISTING_BOOKING,
} from "../actions/booking";
import {
  SAVED_NEW_CUSTOMER_DATA,
  SAVED_EDITED_CUSTOMER_DATA,
  GOT_CUSTOMER_PROFILE_DATA,
  UPDATE_CUSTOMER_NOT_YET_SAVED_FLAG,
  LIMITED_PERMISSIONS,
  UPDATE_SHOULD_SAVE_APPOINTMENT_ONCE_WE_GO_BACK_FROM_CUSTOMER_PROFILE,
} from "../actions/customerProfile";
import {
  GOT_INVOICE,
  CREATED_INVOICE,
  UPDATED_INVOICE,
  REFUNDED_INVOICE_PAYMENT,
  CHARGED_EXISTING_CARD,
  GOT_BOOKING_PAYMENTS,
  GET_INVOICE,
} from "../actions/checkoutAppointmentStep";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";

import {
  appointmentStepInitialState,
  paymentStatusEnum,
  offersStatusEnum,
  getEmptyCustomer,
} from "../state/initialState";
import objectAssign from "object-assign";
import { clone } from "./helper";
import {
  apiLocalTimeToMoment,
  isInRange,
  convertTimeFromApi,
  getAppointmentEndTime,
  getLocationId,
  formatPhone,
  updateDisabledInTimeList,
} from "./../utils/helpers";
import moment from "moment";

function loadFromScratch() {
  return appointmentStepInitialState;
}

export default (state = loadFromScratch(), action) => {
  let newStatus;
  let clonedAppointmentStepData;
  let newTimeItem;
  let clonedPermissions;
  switch (action.type) {
    case GET_CUSTOMERS_BASED_ON_FILTER:
      newStatus = clone(state.appointmentStepData);
      newStatus.loadingCustomersList = true;
      return objectAssign({}, state, { appointmentStepData: newStatus });
    case UPDATE_SHOULD_SAVE_APPOINTMENT_ONCE_WE_GO_BACK_FROM_CUSTOMER_PROFILE:
      return objectAssign({}, state, {
        shouldSaveAppointmentOnceWeGoBackFromCustomerProfile: action.data,
      });
    case REMOVE_OFFER_FROM_FORM:
      newStatus = clone(state.appointmentStepData);
      newStatus.multiServiceList[0].offerPrice = 0;
      if (newStatus.multiServiceList[0].originalOfferprice > 0) {
        // in case we loaded the offer from database, dont do this
        newStatus.multiServiceList[0].selectedService.price =
          newStatus.multiServiceList[0].originalOfferprice;
      }
      newStatus.multiServiceList[0].originalOfferprice = 0;
      return objectAssign({}, state, { appointmentStepData: newStatus });
    case GOT_PURCHASED_OFFER:
      if (action.data.found) {
        newStatus = clone(state.appointmentStepData);
        newStatus.multiServiceList[0].selectedService = {
          id: action.data.purchase.serviceid,
        };
        if (action.data.purchase) {
          newStatus.selectedCustomer.firstname = action.data.purchase.firstname;
          newStatus.selectedCustomer.lastname = action.data.purchase.lastname;
          newStatus.selectedCustomer.email = action.data.purchase.emailaddress;
        }
        newStatus.multiServiceList[0].offerPrice = parseInt(
          action.data.offer.offerprice,
          10
        );
        newStatus.multiServiceList[0].originalOfferprice = parseInt(
          action.data.offer.normalprice,
          10
        );
        if (newStatus.multiServiceList[0].originalOfferprice > 0) {
          // in case we loaded the offer from database, dont do this
          newStatus.multiServiceList[0].selectedService.price =
            newStatus.multiServiceList[0].offerPrice;
        }
      } else {
        newStatus = state.appointmentStepData;
      }
      return objectAssign({}, state, { appointmentStepData: newStatus });
    case GOT_SIBBLING_BOOKING:
      newStatus = clone(state);

      const status =
        action.data.appointmentStepData.multiServiceList[0].sibblingStatus; //DES-751 Dont add cancelled appointments to the sibbling list.
      if (status !== 5 && status !== 6) {
        newStatus.appointmentStepData.multiServiceList = newStatus.appointmentStepData.multiServiceList.concat(
          action.data.appointmentStepData.multiServiceList
        );
      }

      if (newStatus.appointmentStepData.isAppointmentDragAndDrop) {
        newStatus.appointmentStepData.multiServiceList[0].selectedDate =
          newStatus.appointmentStepData.originalSelectedDateOnceAppointmentWasOpened;
        newStatus.appointmentStepData.multiServiceList[0].selectedTime =
          newStatus.appointmentStepData.originalSelectedTimeOnceAppointmentWasOpened;

        if (
          newStatus.appointmentStepData
            .originalSelectedStaffOnceAppointmentWasOpenedId
        ) {
          // enable drag and drop between staff for multiservice
          newStatus.appointmentStepData.multiServiceList[0].selectedStaff = newStatus.appointmentStepData.staffList.find(
            (x) =>
              x.id ==
              newStatus.appointmentStepData
                .originalSelectedStaffOnceAppointmentWasOpenedId
          );
        }
        action.data.appointmentStepData.isAppointmentDragAndDrop = false;
      }

      if (!newStatus.limitedPermissions.canEditAllBookings) {
        let servicesCurrentUserCanAccess = newStatus.appointmentStepData.multiServiceList.filter(
          (x) =>
            x.selectedStaff.id ==
            newStatus.appointmentStepData.currentStaffLoggedIn
        );
        newStatus.limitedPermissions.bookingsEditableByCurrentUser = servicesCurrentUserCanAccess.map(
          (x) => x.bookingId
        );
      }

      return objectAssign({}, state, newStatus);
    case GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      let clonedBookingResults = clone(action.data);
      let bookingsTimeLine = clonedBookingResults.bookingstimeline;
      const doubleBookingsTimeline =
        clonedBookingResults.doublebookingstimeline;
      // checking if double bookings enabled
      const bookings =
        state.appointmentStepData.doubleBookingEnabled === true
          ? doubleBookingsTimeline
          : bookingsTimeLine.concat(doubleBookingsTimeline);

      let selectedDate = "";
      let bookingWeUpdated = clonedAppointmentStepData.multiServiceList.findIndex(
        (x) => x.bookingId == action.data.bookingId
      );
      if (bookingWeUpdated > -1) {
        selectedDate =
          clonedAppointmentStepData.multiServiceList[bookingWeUpdated]
            .selectedDate;
      } else {
        selectedDate =
          clonedAppointmentStepData.multiServiceList[0].selectedDate;
      }
      selectedDate = selectedDate.replace ? selectedDate : selectedDate._i;
      selectedDate = selectedDate.replace(":", "").replace(/-/g, "") + "L";

      clonedAppointmentStepData.timeList.forEach((item) => {
        item.disabled = false;
      }); // start with a clean list

      clonedAppointmentStepData.unavailableTimeList = [];
      if (state.appointmentStepData.doubleBookingEnabled) {
        clonedAppointmentStepData.timeSlotsContainingAppointments = [];
        bookingsTimeLine.forEach((booking, i) => {
          if (
            selectedDate.split("T")[0] == booking.localstarttime.split("T")[0]
          ) {
            //fill only for current date
            const localstarttime = apiLocalTimeToMoment(booking.localstarttime);
            const localendtime = apiLocalTimeToMoment(booking.localendtime);

            clonedAppointmentStepData.timeSlotsContainingAppointments.push({
              from: convertTimeFromApi(localstarttime),
              to: convertTimeFromApi(localendtime),
            });
          }
        });
      }

      updateDisabledInTimeList(
        clonedAppointmentStepData.timeList,
        selectedDate,
        bookings,
        action.data.item,
        clonedAppointmentStepData.multiServiceList
      );

      if (bookings.length == 0) {
        clonedAppointmentStepData.timeList.forEach((x) => {
          x.disabled = false;
        });
      }
      // Best comment number 2
      if (bookingWeUpdated > -1) {
        clonedAppointmentStepData.multiServiceList[
          bookingWeUpdated
        ].loadingTimesForCurrentResource = false;
        clonedAppointmentStepData.multiServiceList[
          bookingWeUpdated
        ].loadedBookingForResourceWithinDates = true;
      } else {
        clonedAppointmentStepData.multiServiceList[0].loadingTimesForCurrentResource = false;
        clonedAppointmentStepData.multiServiceList[0].loadedBookingForResourceWithinDates = true;
      }
      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });

    case UPDATED_GLOBAL_ERROR_MESSAGE:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      clonedAppointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot = false; //this is here to avoid closing after an error when drag and drop happens
      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      clonedAppointmentStepData.multiServiceList.find(
        (x) => x.bookingId == action.data.bookingId
      ).loadingTimesForCurrentResource = true;

      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case UPDATED_APPOINTMENT_STEP_DATA:
      return objectAssign({}, state, { appointmentStepData: action.data });
    case UPDATED_STATE_DATE_PICKER_APPOINTMENT:
      return objectAssign({}, state, {
        openDatePickerAppointment: action.data,
      });
    case UPDATE_CUSTOMER_NOT_YET_SAVED_FLAG:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      clonedAppointmentStepData.selectedCustomer.notYetSaved = action.data;
      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case UPDATE_CUSTOMER_DROPDOWN_VISIBILITY:
      return objectAssign({}, state, { customerDropdownOpen: action.data });
    case UPDATE_CURRENTLY_LOGGED_IN_STAFF:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      clonedAppointmentStepData.currentStaffLoggedIn = action.data;
      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case GOT_PROFILE_FOR_CURRENT_USER:
      let clonedPermissions = clone(state.limitedPermissions);

      (action.data.roles || []).forEach((role) => {
        if (role.name == "access-view-calendar") {
          clonedPermissions.canEditAllBookings = false;
          let servicesCurrentUserCanAccess = state.appointmentStepData.multiServiceList.filter(
            (x) =>
              x.selectedStaff.id ==
              state.appointmentStepData.currentStaffLoggedIn
          );
          //let bookingwithIds = state.appointmentStepData.multiServiceList.filter(x => x.bookingId);
          clonedPermissions.bookingsEditableByCurrentUser = servicesCurrentUserCanAccess.map(
            (x) => x.bookingId
          );
          // if(bookingwithIds.length == 0 && servicesCurrentUserCanAccess.length > 0){ // when loading existinBooking, this reducer is called before GOT_EXISTING_BOOKING with multiserviceList without bookingID. DES-592
          //   clonedPermissions.userRolesLoadedWithoutBooking = true;
          // }
        } else if (role.name == "access-view-payment-info") {
          clonedPermissions.canCheckoutAllBookings = false;
        } else if (role.name == "access-view-all-cust") {
          clonedPermissions.canEditCustomerProfile = false;
        }
      });

      //fix roles for edge cases
      if (
        action.data.roles &&
        !action.data.roles.find((role) => role.name == "service-provider")
      ) {
        // service provider can do anything
        if (
          !action.data.roles.find(
            (role) => role.name == "access-edit-payment-info"
          )
        ) {
          clonedPermissions.canCheckoutAllBookings = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-all-cust"
          ) &&
          !action.data.roles.find((role) => role.name == "access-edit-all-cust")
        ) {
          clonedPermissions.canCreateCustomerProfile = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-payment-info"
          ) &&
          !action.data.roles.find(
            (role) => role.name == "access-edit-payment-info"
          )
        ) {
          clonedPermissions.canViewAndEditCheckoutInvoicesForAllBookings = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-all-cust"
          ) &&
          !action.data.roles.find((role) => role.name == "access-edit-all-cust")
        ) {
          clonedPermissions.canSearchForCustomers = false;
        }
      }

      return objectAssign({}, state, {
        currentlyLoggedInUserid: action.data.id,
        roles: action.data.roles,
        limitedPermissions: clonedPermissions,
      });
    case LIMITED_PERMISSIONS:
      clonedPermissions = clone(state.limitedPermissions);
      let finalPermissions = objectAssign({}, clonedPermissions, action.data);
      return objectAssign({}, state, { limitedPermissions: finalPermissions });

    case GOT_CUSTOMER_PROFILE_DATA:
      let copyOfAppointmentStepData = clone(state.appointmentStepData);
      copyOfAppointmentStepData.selectedCustomer.noShow = action.data.noshow;
      copyOfAppointmentStepData.selectedCustomer.blocked = action.data.blocked;
      copyOfAppointmentStepData.address = action.data.address; // we update the address of the appointment with the customer address

      return objectAssign({}, state, {
        appointmentStepData: copyOfAppointmentStepData,
      });
    case SAVED_NEW_CUSTOMER_DATA:
    case SAVED_EDITED_CUSTOMER_DATA:
      clonedAppointmentStepData = clone(state.appointmentStepData);
      let phonenumber = "";
      let email = "";
      if (action.data.emails && action.data.emails.length > 0) {
        email = (action.data.emails.find((x) => x.primary) || {}).email;
      }
      if (action.data.phonenumbers && action.data.phonenumbers.length > 0) {
        phonenumber = (action.data.phonenumbers.find((x) => x.primary) || {})
          .number;
      }
      let shouldThisCustomerBeEditable = true;
      if (
        clonedAppointmentStepData.appointmentDatabaseCustomerId ==
        action.data.id
      ) {
        shouldThisCustomerBeEditable = false;
      }
      newStatus = {
        firstname: action.data.firstname,
        lastname: action.data.lastname,
        email: email,
        phone: phonenumber,
        id: action.data.id,
        notYetSaved: shouldThisCustomerBeEditable,
      };

      clonedAppointmentStepData.selectedCustomer = objectAssign(
        getEmptyCustomer(),
        newStatus
      );

      clonedAppointmentStepData.address = action.data.address; // we update the address of the appointment with the customer address

      clonedAppointmentStepData.customerNameOrPhonenumberSearchQuery = "";
      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case GOT_CUSTOMERS_BASED_ON_FILTER:
      newStatus = clone(state.appointmentStepData);
      let customerList =
        action.data &&
        action.data.customerlist &&
        action.data.customerlist.length > 0
          ? action.data.customerlist
          : [];

      customerList.map((o) => {
        if (o.phone) {
          o.phone = formatPhone(o.phone);
        }
        o.noShow = o.noshowcount;
      });

      newStatus.customerList = customerList;
      newStatus.loadingCustomersList = false;

      return objectAssign({}, state, { appointmentStepData: newStatus });
    case SAVED_BOOKING_FORM:
      let clonedStepData = clone(state.appointmentStepData);
      clonedPermissions = clone(state.limitedPermissions);

      if (action.data.currentBookingId) {
        if (
          clonedPermissions.bookingsEditableByCurrentUser.length > 0 &&
          clonedPermissions.bookingsEditableByCurrentUser[0] == undefined
        ) {
          clonedPermissions.bookingsEditableByCurrentUser[0] =
            action.data.currentBookingId;
        } else {
          clonedPermissions.bookingsEditableByCurrentUser.push(
            action.data.currentBookingId
          );
        }
      }

      clonedStepData = objectAssign(
        {},
        clonedStepData,
        action.data.appointmentStepData
      );
      clonedStepData.appointmentDatabaseCustomerId =
        action.data.appointmentStepData.selectedCustomer.id;
      return objectAssign({}, state, {
        appointmentStepData: clonedStepData,
        limitedPermissions: clonedPermissions,
        isSibblingsMissingInUpdate: action.data.isSibblingsMissingInUpdate,
      });
    case MOVE_APPOINTMENT_TRIGGERED:
      clonedAppointmentStepData = clone(state.appointmentStepData);

      newTimeItem = action.data.time;

      if (!action.data.time.index) {
        if (
          !clonedAppointmentStepData.timeList.find(
            (x) => x.value == newTimeItem.value
          )
        ) {
          //if time doesnt exist in list, add it
          clonedAppointmentStepData.timeList.push(newTimeItem);
        }
      } else {
        clonedAppointmentStepData.multiServiceList[0].selectedTime =
          action.data.time;
      }
      clonedAppointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot = true;
      clonedAppointmentStepData.selectedTimeBeforeWeOverrodeRecurringAppointment = newTimeItem;
      clonedAppointmentStepData.selectedDateBeforeWeOverrodeRecurringAppointment =
        action.data.date;
      clonedAppointmentStepData.isAppointmentDragAndDrop = true;

      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case UPDATED_APPOINTMENT_STEP_START_DATE_TIME:
      clonedAppointmentStepData = clone(state.appointmentStepData);

      clonedAppointmentStepData.multiServiceList[0].selectedDate =
        action.data.date;
      newTimeItem = convertTimeFromApi(action.data.time);

      clonedAppointmentStepData.originalSelectedDateOnceAppointmentWasOpened =
        action.data.date;
      clonedAppointmentStepData.originalSelectedTimeOnceAppointmentWasOpened = newTimeItem;
      clonedAppointmentStepData.originalSelectedStaffOnceAppointmentWasOpenedId =
        action.data.selectedStaffId;

      clonedAppointmentStepData.multiServiceList[0].originalSelectedDateOnceAppointmentWasOpened =
        action.data.date; //DES-713 use for double booking
      clonedAppointmentStepData.multiServiceList[0].originalSelectedTimeOnceAppointmentWasOpened = newTimeItem;
      clonedAppointmentStepData.multiServiceList[0].originalSelectedStaffOnceAppointmentWasOpenedId =
        action.data.selectedStaffId;

      clonedAppointmentStepData.multiServiceList[0].selectedTime = newTimeItem;
      if (!action.data.time.index) {
        if (
          !clonedAppointmentStepData.timeList.find(
            (x) => x.value == newTimeItem.value
          )
        ) {
          //if time doesnt exist in list, add it
          clonedAppointmentStepData.timeList.push(newTimeItem);
        }
      } else {
        clonedAppointmentStepData.multiServiceList[0].selectedTime =
          action.data.time;
      }
      clonedAppointmentStepData.multiServiceList[0].selectedStaff = {
        id: action.data.selectedStaffId,
      };
      clonedAppointmentStepData.multiServiceList[0].selectedService = {
        id: action.data.selectedServiceId,
      };
      clonedAppointmentStepData.multiServiceList[0].selectedLocation = {
        id: action.data.selectedLocationId,
      };

      return objectAssign({}, state, {
        appointmentStepData: clonedAppointmentStepData,
      });
    case UPDATE_SERVICE_DROPDOWN_VISIBILITY:
      return objectAssign({}, state, { serviceDropdownOpen: action.data });
    case GOT_STAFF_SERVICES_AND_MORE:
      let clonedLimitedPermissions = clone(state.limitedPermissions);
      newStatus = clone(state.appointmentStepData);

      if (!action || !action.data || !action.data.services) {
        console.error("bookingformfailed", JSON.stringify(action.data));
      }
      let sortedServices = action.data.services
        .sort((a, b) => {
          if (a.order > b.order) {
            return 1;
          } else if (a.order < b.order) {
            return -1;
          } else {
            return 0;
          }
        })
        .filter((x) => !!x.categories[0])
        .sort((a, b) => {
          if (a.categories[0].order > b.categories[0].order) {
            return 1;
          } else if (a.categories[0].order < b.categories[0].order) {
            return -1;
          } else {
            return 0;
          }
        });

      newStatus.serviceList = action.data.services;
      action.data.services.map((o) => {
        o.duration = moment
          .utc(moment.duration(o.duration)._milliseconds)
          .format("HH:mm");
      });
      newStatus.staffList = action.data.resources;
      newStatus.organizationId = action.data.organizationid;
      newStatus.businessName = action.data.name;
      newStatus.paymentsEnabled = action.data.paymentsenabled;
      window.ORG_ID = action.data.organizationid; //TODO : REFACTOR THIS OUT ONCE WE HAVE RE-DONE THE CALENDAR
      const locationId = getLocationId();
      const currentLocation = action.data.locations.find(
        (location) => location.id.toString() === locationId
      );
      const timezone =
        currentLocation && currentLocation.timezone
          ? currentLocation.timezone.id
          : action.data.timezone.id;
      newStatus.timezone = timezone;
      window.userTimezone = timezone;
      newStatus.doubleBookingEnabled = action.data.doublebookingenabled;

      if (
        newStatus.selectedStaff &&
        newStatus.selectedStaff.id &&
        newStatus.staffList &&
        newStatus.staffList.length > 0
      ) {
        //this is because sometimes the calendar will pass the staff and we store it inside selectedStaff.id before we get the details from the database
        newStatus.selectedStaff = newStatus.staffList.find(
          (x) => x.id == newStatus.selectedStaff.id
        );
      }
      if (
        newStatus.selectedService &&
        newStatus.selectedService.id &&
        newStatus.serviceList &&
        newStatus.serviceList.length > 0
      ) {
        //this is because sometimes the calendar will pass the service and we store it inside selectedService.id before we get the details from the database
        newStatus.selectedService = clone(
          newStatus.serviceList.find(
            (x) => x.id == newStatus.selectedService.id
          )
        ); // avoid updating the service of the list
      }

      // if (!state.roles.find(role => role.name == 'service-provider')) { // service provider can do anything
      //   if (state.roles.find(role => role.name == 'access-view-calendar') && newStatus.staffList.length == 1) {
      //    clonedLimitedPermissions.canEditAllBookings = true;
      //   }
      // }

      return objectAssign({}, state, {
        appointmentStepData: newStatus,
        finishedLoadingServicesAndOrganizationData: true,
        businessCountryCode: action.data.address.countrycode,
        limitedPermissions: clonedLimitedPermissions,
      });
    case UPDATE_IS_SHOWING_ADDRESS_FORM: {
      return objectAssign({}, state, {
        isShowingAddressForm: action.isShowing,
      });
    }
    case GET_EXISTING_BOOKING:
      newStatus = clone(state);
      newStatus.finishedLoadingBooking = false;
      newStatus.loadingExistingBooking = true;
      return objectAssign({}, state, newStatus);
    case GOT_EXISTING_BOOKING:
      newStatus = clone(state);

      action.data.appointmentStepData.multiServiceList = action.data.appointmentStepData.multiServiceList.map(
        (o, i) => {
          if (!newStatus.appointmentStepData.multiServiceList[i]) {
            logger.warn("service numbers dont match");
          }
          return objectAssign(
            {},
            newStatus.appointmentStepData.multiServiceList[i],
            o
          );
        }
      );

      if (!newStatus.limitedPermissions.canEditAllBookings) {
        let servicesCurrentUserCanAccess = action.data.appointmentStepData.multiServiceList.filter(
          (x) =>
            x.selectedStaff.id ==
            newStatus.appointmentStepData.currentStaffLoggedIn
        );
        newStatus.limitedPermissions.bookingsEditableByCurrentUser = servicesCurrentUserCanAccess.map(
          (x) => x.bookingId
        );
      }

      action.data.appointmentStepData.multiServiceList[0].loadedBookingForResourceWithinDates =
        state.appointmentStepData.multiServiceList[0].loadedBookingForResourceWithinDates;

      let mergedData = objectAssign(
        {},
        newStatus.appointmentStepData,
        action.data.appointmentStepData
      );

      if (action.data.invoiceData) {
        if (action.data.invoiceData.status == "PAID") {
          mergedData.paymentStatus = paymentStatusEnum.STATUS_PAID;
        } else {
          if (action.data.invoiceData.balanceamount > 0) {
            mergedData.paymentStatus = paymentStatusEnum.STATUS_PARTIAL;
          } else {
            mergedData.paymentStatus = paymentStatusEnum.STATUS_UNPAID;
          }
        }
        mergedData.paymentStatusReceived = true;
      } else {
        mergedData.paymentStatus = paymentStatusEnum.STATUS_UNKNOWN;
        mergedData.paymentStatusReceived = false;
      }

      if (action.data.loadedCache) {
        newStatus.loadedCachedData = true;
      }
      if (
        !mergedData.selectedTimeBeforeWeOverrodeRecurringAppointment ||
        !mergedData.selectedTimeBeforeWeOverrodeRecurringAppointment.value
      )
        mergedData.selectedTimeBeforeWeOverrodeRecurringAppointment = clone(
          state.appointmentStepData.multiServiceList[0].selectedTime
        );
      if (!mergedData.selectedDateBeforeWeOverrodeRecurringAppointment)
        mergedData.selectedDateBeforeWeOverrodeRecurringAppointment = clone(
          state.appointmentStepData.multiServiceList[0].selectedDate
        );

      newStatus.finishedLoadingBooking = true;
      mergedData.loadingExistingBooking = false;
      mergedData.appointmentDatabaseCustomerId =
        action.data.appointmentStepData.selectedCustomer.id;

      let appointmentStepDataBeforeUserHasMadeAnyChanges = clone(
        state.appointmentStepData
      );

      return objectAssign(
        {},
        state,
        newStatus,
        { appointmentStepData: mergedData },
        {
          appointmentStepDataBeforeUserHasMadeAnyChanges: appointmentStepDataBeforeUserHasMadeAnyChanges,
        }
      );
    case UPDATE_TEMP_BOOKING_ADDRESS:
      return objectAssign({}, state, { temporaryBookingAddress: action.data });
    case CLEAR_ADDRESS_FORM_IN_APPOINTMENT_STEP:
      return objectAssign({}, state, {
        temporaryBookingAddress:
          appointmentStepInitialState.temporaryBookingAddress,
      });
    case GET_INVOICE:
      newStatus = clone(state.appointmentStepData);
      newStatus.loadingInvoice = true;
      return objectAssign({}, state, { appointmentStepData: newStatus });
    case CREATED_INVOICE:
    case UPDATED_INVOICE:
    case GOT_INVOICE:
      newStatus = clone(state.appointmentStepData);
      if (action.data) {
        if (action.data.status == "PAID") {
          newStatus.paymentStatus = paymentStatusEnum.STATUS_PAID;
        } else {
          if (action.data.balanceamount > 0) {
            newStatus.paymentStatus = paymentStatusEnum.STATUS_PARTIAL;
          } else {
            newStatus.paymentStatus = paymentStatusEnum.STATUS_UNPAID;
          }
        }
        newStatus.paymentStatusReceived = true;
      }
      newStatus.loadingInvoice = false;
      return objectAssign({}, state, { appointmentStepData: newStatus });
    case REFUNDED_INVOICE_PAYMENT:
    case CHARGED_EXISTING_CARD:
    case GOT_BOOKING_PAYMENTS:
      newStatus = clone(state.appointmentStepData);
      if (action.data.invoice) {
        if (action.data.invoice.status == "PAID") {
          newStatus.paymentStatus = paymentStatusEnum.STATUS_PAID;
        } else {
          if (action.data.invoice.balanceamount > 0) {
            newStatus.paymentStatus = paymentStatusEnum.STATUS_PARTIAL;
          } else {
            newStatus.paymentStatus = paymentStatusEnum.STATUS_UNPAID;
          }
        }
      }
      return objectAssign({}, state, { appointmentStepData: newStatus });
    default:
      return state;
  }
  return state;
};
